import { useLandingProjectSource } from '../useLandingProjectSource';

import css from './inputBorder.css';

export const useAuthInputBorderClassName = (): string => {
    const source = useLandingProjectSource();
    return css[source];
};
